export const LogoMark = ({ size = 48 }) => (
  <span className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#090909] ring-1 ring-[#C5A059]/60" style={{ width: size, height: size }}>
    <img src="/logo-mark.png" alt="Logo Estetica e Benessere" data-testid="brand-logo" style={{ height: size * 0.82 }} className="object-contain" />
  </span>
);

export const LogoFull = ({ className = "" }) => (
  <img src="/logo-wide.jpg" alt="Estetica e Benessere di Micol Pennacchietti" data-testid="brand-logo-full" className={className} />
);

export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-3">
    <LogoMark size={44} />
    <div className="leading-tight">
      <div className={`font-serif text-xl ${light ? "text-[#F6F1EA]" : "text-[#121212]"}`}>Estetica</div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">e Benessere</div>
      <div className="mt-0.5 text-lg leading-none text-[#C5A059]" style={{ fontFamily: "'Great Vibes', cursive" }} data-testid="brand-owner-name">Pennacchietti Micol</div>
    </div>
  </div>
);
